module.exports = __webpack_public_path__ + "static/media/loading.1c25fb73.svg";